export const version = '231123-b1c465e';



// WEBPACK FOOTER //
// ./src/version.js